import { ISymbolData } from '../parseToTree.types';
import { getSymbolsChecks } from './getSymbolsChecks/getSymbolsChecks';
import {
  IGetSymbolsPositionsOptions,
  IGetSymbolsPositionsResult,
} from './getSymbolsPositions.types';
import { removeDublicatePositions } from './removeDublicatePositions/removeDublicatePositions';

export const getSymbolsPositions = (
  opts: IGetSymbolsPositionsOptions
): IGetSymbolsPositionsResult => {
  const { text, userMentions = [], hasBotCommands = false, keyWords = [] } = opts;
  const symbolsChecks = getSymbolsChecks({ keyWords, userMentions, hasBotCommands });
  const symbolsPositions: Record<string, ISymbolData[]> = {
    '***': [],
    '**': [],
    '*': [],
    '~~': [],
    __: [],
    '@': [],
    '/': [],
    link: [],
    email: [],
    '[': [],
    ']': [],
    '```': [],
  };

  if (keyWords && keyWords.length > 0) {
    keyWords.forEach(({ keyWord }) => {
      symbolsPositions[keyWord[0]] = [];
    });
  }

  let hasSymbols = false;

  for (let index = 0; index < text.length; index++) {
    const char = text[index];

    const symbolsCheck = symbolsChecks[char];

    if (!symbolsCheck) {
      continue;
    }

    if (!hasSymbols) {
      hasSymbols = true;
    }

    symbolsCheck({ text, index, symbolMatches: symbolsPositions });
  }

  if (!hasSymbols) {
    return {
      hasSymbols,
      symbolsPositions,
    };
  }

  return {
    symbolsPositions: removeDublicatePositions({ symbolsPositions }),
    hasSymbols,
  };
};
